import validate from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_@upstash+redis@1.34.6_db0@0.3.1_d_88c04a0fe966f9a659085d2bc8d0f587/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_@upstash+redis@1.34.6_db0@0.3.1_d_88c04a0fe966f9a659085d2bc8d0f587/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts"),
  otp: () => import("/app/middleware/otp.ts")
}